// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3oCk0","additionalInfo":"AgreementModal_additionalInfo__5y4Ex"};